import user from './user'
import device from './device'
import codegen from './codegen'
import system from './system'
import report from './report'
import manage from './manage'
import riskpos from './riskpos'

export default {
  user,
  device,
  codegen,
  system,
  report,
  manage,
  riskpos
}
